import type { AppFeatures } from "./types";

export type FileDownloadCapability = "supported" | "unsupported" | "unknown";

export const getFileDownloadCapability = (
  isApp: boolean,
  features: AppFeatures,
): FileDownloadCapability => {
  if (!isApp) {
    return "supported";
  }
  if (features.fileDownloadAccess === true) {
    return "supported";
  }
  if (features.fileDownloadAccess === false) {
    return "unsupported";
  }
  return "unknown";
};

const getErrorMessage = (error: unknown): string => {
  if (typeof error === "string") {
    return error;
  }
  if (error instanceof Error) {
    return error.message || "";
  }
  if (error && typeof error === "object") {
    const e = error as {
      message?: unknown;
      msg?: unknown;
      errMsg?: unknown;
      error?: unknown;
    };
    if (typeof e.message === "string") {
      return e.message;
    }
    if (typeof e.msg === "string") {
      return e.msg;
    }
    if (typeof e.errMsg === "string") {
      return e.errMsg;
    }
    if (typeof e.error === "string") {
      return e.error;
    }
  }
  return "";
};

export const isLikelyFileDownloadNotSupportedError = (
  error: unknown,
): boolean => {
  const message = getErrorMessage(error).toLowerCase();
  if (!message) {
    return false;
  }
  return (
    // 原生双端已确认会返回 Unknown method（旧壳不支持 downloadFile）。
    // 旧壳无响应时，Bridge 层会在 Web 侧抛 request timeout，也按不支持处理。
    message.includes("unknown method") || message.includes("request timeout")
  );
};
